export enum AgentNumberStatusId {
  Active = 1,
  Inactive = 2,
  Terminated = 3,
}

export type AgentNumberStatus = {
  name: string;
  id: AgentNumberStatusId;
};

export const ActiveAgentNumberStatus = {
  name: "Active",
  id: AgentNumberStatusId.Active,
};
